import uuidV4 from 'lib/string/uuidV4Utils'

export function createCheckoutPaymentId(): string {
  return uuidV4()
}

export function getSplitPaymentAdditionalInfo(checkoutPaymentId: string): Pick<App.PaymentAdditionalInfo, 'splitPayment'> {
  return {
    splitPayment: { checkoutPaymentId },
  }
}
